import { useState } from "react";
import { useAxios } from "../../../utils/useAxios";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";

/**
 * @typedef {Object} DeleteLessonParams
 * @property {number} lessonId
 * @property {()=> void} onSuccess
 */

/**
 * Custom hook to delete a lesson detail , which take lessonId as parameter and success function
 * which is called when lesson is deleted successfully
 */
export const useDeleteLesson = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const { axiosInstance } = useAxios();
  const deleteLesson = async ({ lessonId, onSuccess }) => {
    setLoading(true);
    setError("");
    setSuccess(false);
    try {
      await axiosInstance.delete(
        `${TENANT_DOMAIN}/lesson/destroy/${lessonId}`,
      );
      setSuccess(true);
      onSuccess();
    } catch (error) {
      if (error?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    error,
    success,
    deleteLesson,
  };
};

